export const hero = {
    display: 'grid', 
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: '30px', 
    mb: '80px'
}
